import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { FaBars } from 'react-icons/fa';

const HeaderContainer = styled.header`
  background-color: ${props => props.theme.colors.white};
  box-shadow: ${props => props.theme.shadows.small};
  position: sticky;
  top: 0;
  z-index: 1000;
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 15px;
`;

const Logo = styled.div`
  a {
    font-family: ${props => props.theme.fonts.secondary};
    font-size: ${props => props.theme.fontSizes.xlarge};
    font-weight: ${props => props.theme.fontWeights.bold};
    color: ${props => props.theme.colors.secondaryColor};
    
    &:hover {
      color: ${props => props.theme.colors.primaryColor};
    }
  }
`;

const NavContainer = styled.nav`
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    position: relative;
  }
`;

const MenuToggle = styled.div`
  display: none;
  cursor: pointer;
  font-size: ${props => props.theme.fontSizes.large};
  color: ${props => props.theme.colors.secondaryColor};
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    display: block;
  }
`;

const MainMenu = styled.ul`
  display: flex;
  list-style: none;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    display: ${props => (props.isOpen ? 'flex' : 'none')};
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: ${props => props.theme.colors.white};
    flex-direction: column;
    text-align: center;
    box-shadow: ${props => props.theme.shadows.regular};
  }
`;

const MenuItem = styled.li`
  margin-left: 30px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    margin: 0;
  }
`;

const MenuLink = styled(Link)`
  color: ${props => props.theme.colors.secondaryColor};
  font-weight: ${props => props.theme.fontWeights.medium};
  padding: 10px 0;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    width: ${props => (props.active ? '100%' : '0')};
    height: 2px;
    background-color: ${props => props.theme.colors.primaryColor};
    left: 0;
    bottom: 0;
    transition: ${props => props.theme.transitions.main};
  }
  
  &:hover::after {
    width: 100%;
  }
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    display: block;
    padding: 15px;
    border-bottom: 1px solid ${props => props.theme.colors.grey[200]};
  }
`;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  
  // Close menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);
  
  // Close menu when window is resized beyond mobile breakpoint
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsMenuOpen(false);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  return (
    <HeaderContainer>
      <div className="container">
        <HeaderContent>
          <Logo>
            <Link to="/">KSARC</Link>
            <h3>Kalyanasundaram’s Structural Academy & Research Centre</h3>
          </Logo>
          <NavContainer>
            <MenuToggle onClick={toggleMenu}>
              <FaBars />
            </MenuToggle>
            <MainMenu isOpen={isMenuOpen}>
              <MenuItem>
                <MenuLink to="/" active={location.pathname === '/' ? 1 : 0}>
                  Home
                </MenuLink>
              </MenuItem>
              <MenuItem>
                <MenuLink to="/about" active={location.pathname === '/about' ? 1 : 0}>
                  About Us
                </MenuLink>
              </MenuItem>
              <MenuItem>
                <MenuLink to="/courses" active={location.pathname === '/courses' ? 1 : 0}>
                  Courses
                </MenuLink>
              </MenuItem>
              {/* <MenuItem>
                <MenuLink to="/tnpsc" active={location.pathname === '/tnpsc' ? 1 : 0}>
                  TNPSC Exam
                </MenuLink>
              </MenuItem> */}
              <MenuItem>
                <MenuLink to="/portfolio" active={location.pathname === '/portfolio' ? 1 : 0}>
                  Portfolio
                </MenuLink>
              </MenuItem>
              <MenuItem>
                <MenuLink to="/contact" active={location.pathname === '/contact' ? 1 : 0}>
                  Contact
                </MenuLink>
              </MenuItem>
            </MainMenu>
          </NavContainer>
        </HeaderContent>
      </div>
    </HeaderContainer>
  );
};

export default Header;
